import { Directive } from '@angular/core';
import { LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';

import { entityMultiSelectText } from 'src/app/common-components/multi-select/entity-multi-select-text-content';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

@Directive({
    selector: 'lcs-multi-select-trigger[ndtExtensionMultiSelect]',
    standalone: false
})
export class ExtensionMultiSelectTriggerDirective {
   constructor(trigger: LcsMultiSelectTriggerComponent<ExtensionOption>) {
      trigger.getTextContent = entityMultiSelectText(trigger, 'extension');
   }
}
